import React, { useState } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { AtiaBrand, PasswordField } from "@/components/Atoms";
import { GoogleLogo, Key } from "@phosphor-icons/react";

export default function Login() {
    const nav = useNavigate();
    const [tab, setTab] = useState("clave");
    const [loading, setLoading] = useState(null);
    const [creds, setCreds] = useState({ identifier: "", password: "" });
    const [error, setError] = useState("");

    const handleGoogle = () => {
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const handlePassword = async (e) => {
        e.preventDefault();
        setLoading("login"); setError("");
        try {
            const r = await api.post("/auth/login", creds);
            localStorage.setItem("atia_session_token", r.data.session_token);
            window.location.href = "/dashboard";
        } catch (err) {
            setError(err.response?.data?.detail || "Error");
            setLoading(null);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-[5fr_7fr]">
            <div className="relative hidden lg:flex flex-col justify-between p-10 xl:p-14 text-white overflow-hidden grain-overlay" style={{ background: "#0A191E" }}>
                <div className="absolute inset-0 opacity-25" style={{ backgroundImage: "url('/brand/atia_logo.png')", backgroundSize: "420px", backgroundPosition: "center 60%", backgroundRepeat: "no-repeat" }} />
                <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(10,25,30,0.95), rgba(10,25,30,0.7) 50%, rgba(20,184,166,0.15))" }} />
                <div className="relative z-10"><AtiaBrand invert size="lg" /></div>
                <div className="relative z-10 space-y-6 max-w-md">
                    <div className="overline" style={{ color: "rgba(94, 234, 212, 0.8)" }}>Sistema de Gestión Integrado</div>
                    <h1 className="font-display text-5xl xl:text-6xl font-black tracking-tighter leading-[0.95]">
                        El plan que <span style={{ color: "#5EEAD4" }}>previene la falla</span>.
                    </h1>
                    <p className="text-zinc-300 leading-relaxed max-w-sm">
                        Suscripciones de mantenimiento. Agenda compartida supervisor-técnico-comercial. Cliente ve su ROI: cuánto ahorró ATIA en eventos críticos prevenidos.
                    </p>
                </div>
                <div className="relative z-10 text-[10px] text-zinc-500 font-mono tracking-wider">ATIA-SGI v3.0</div>
            </div>

            <div className="flex flex-col p-6 md:p-12 lg:p-16 bg-white overflow-y-auto">
                <div className="lg:hidden mb-8"><AtiaBrand size="lg" /></div>
                <div className="mb-8">
                    <div className="overline mb-2">Acceso al sistema</div>
                    <h2 className="font-display text-3xl md:text-4xl font-black tracking-tighter mb-3">Inicia sesión</h2>
                </div>

                <div className="flex gap-0 border border-zinc-200 max-w-md mb-6">
                    {[{ v: "clave", l: "Clave" }, { v: "google", l: "Google" }].map(t => (
                        <button key={t.v} onClick={() => setTab(t.v)} className={`flex-1 px-4 py-2 text-xs font-bold uppercase tracking-wider border-r border-zinc-200 last:border-r-0 ${tab === t.v ? "bg-zinc-900 text-white" : "bg-white hover:bg-zinc-50"}`} data-testid={`tab-${t.v}`}>
                            {t.l}
                        </button>
                    ))}
                </div>

                {tab === "clave" && (
                    <form onSubmit={handlePassword} className="max-w-md space-y-4" data-testid="login-form">
                        <label className="block">
                            <div className="overline mb-1.5">Identificador</div>
                            <input className="input-atia font-mono" placeholder="CC, email o NIT" value={creds.identifier} onChange={e => setCreds({ ...creds, identifier: e.target.value })} required data-testid="login-identifier" />
                            <p className="text-[11px] text-zinc-500 mt-1.5">Técnico/comercial/supervisor: tu cédula. Cliente: NIT de la empresa.</p>
                        </label>
                        <label className="block">
                            <div className="overline mb-1.5">Clave</div>
                            <PasswordField value={creds.password} onChange={v => setCreds({ ...creds, password: v })} testid="login-password" autoComplete="current-password" />
                        </label>
                        {error && <div className="p-3 bg-red-50 border border-red-200 text-red-800 text-sm" data-testid="login-error">{error}</div>}
                        <button type="submit" disabled={loading === "login"} className="btn-accent w-full flex items-center justify-center gap-2" data-testid="login-submit">
                            <Key size={16} weight="bold" /> {loading === "login" ? "Verificando…" : "Entrar"}
                        </button>
                    </form>
                )}

                {tab === "google" && (
                    <div className="max-w-md">
                        <button onClick={handleGoogle} className="w-full border border-zinc-300 hover:border-teal-500 flex items-center justify-center gap-3 px-6 py-3 font-semibold transition-colors duration-200" data-testid="google-login-btn">
                            <GoogleLogo size={20} weight="bold" /> Continuar con Google
                        </button>
                        <p className="text-xs text-zinc-500 mt-3">Para usuarios con cuenta Google corporativa. El rol asignado por defecto es Técnico — el administrador puede cambiarlo.</p>
                    </div>
                )}
            </div>
        </div>
    );
}
